module.exports = __webpack_public_path__ + "static/media/flag_english.29c9f4a8.png";